import { Worksheet } from "exceljs";
import i18n from "i18n";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { CustomPropertyStore } from "modules/customProperties/CustomPropertyStore";
import { CustomPropertyModel } from "modules/customProperties/CustomPropertyModel";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { ERowType } from "common/enums";
import { roundBy } from "utils/DecimalUtils";
import { createAlphabet } from "./ReportUtils";
import { monetaryFormat } from "./constants";
import {
  blackColor,
  borderThinStyle,
  fillGray02,
  fillGreen,
  fillLighterGreen,
  fillLightGray,
  fillLightGreen,
  fontNormal,
  whiteColor,
} from "./ReportStyles";

const getDataEAPAnalytical = (worksheet: Worksheet) => {
  const stageCustomProperties = CustomPropertyStore.getWBSCustomProperties();
  const letters = ["T", "U", "V", "W", "X", "Y", "Z"].concat(createAlphabet());
  const rules = WBSPropertiesStore.getRules(2);

  worksheet = setColumnHeader(worksheet, stageCustomProperties, letters);

  let formatedData: any = [];
  let totalPercentage = 0;
  let totalPercentageTasks = 0;
  let { dataTable, WBSRows } = WBSStore;
  let globalBdi = WBSStore.WBS.data.bdi.percentual;
  for (let i = 0; i < dataTable.length; i++) {
    let data = dataTable[i].data;
    let id = dataTable[i].id;
    let tree = (data as any).tree;
    let count = tree.match(/\./g);
    let indexTree = 0;
    if (count) {
      indexTree = count.length;
    }
    totalPercentage =
      (roundBy(data.total || 0, rules) * 100) / WBSStore.WBS.data.totalCost;
    totalPercentage = isNaN(totalPercentage) ? 0 : totalPercentage;
    let customProperties = data.customProperties;
    let priceLabor = 0,
      priceMat = 0,
      priceOther = 0;
    let {
      priceLabor: tempPriceLabor,
      priceMat: tempPriceMat,
      priceOther: tempPriceOther,
    } = CostPlanStore.getRowLaborAndMaterialPrice(WBSRows, id);
    priceLabor = Number(tempPriceLabor);
    priceMat = Number(tempPriceMat);
    priceOther = Number(tempPriceOther);
    formatedData.push({
      "Cód. Estruturado": tree,
      Fonte: data.rateLibraryId ? "RL" : "WBS", // TODO-706 - Origem
      Código: data.rowCode,
      Descrição: data.description,
      Quantidade: data.quantity,
      "Unid.": data.unit,
      "Custo Unitário": roundBy(data.unitCost || 0, rules),
      "Custo M. O.": priceLabor,
      "Custo Mat.": priceMat,
      "Custo Outros": priceOther,
      Total: roundBy(data.total || 0, rules),
      "Preço de Venda":
        roundBy(data.vendaBdi || 0, rules) !== Infinity
          ? roundBy(data.vendaBdi || 0, rules)
          : undefined,
      "Preço Total": roundBy(data.totalBdi || 0, rules),
      "BDI (%)": data.bdi ? data.bdi : globalBdi,
      "%": totalPercentage,
      isStage: data.rowType == ERowType.STAGE ? true : false,
      isTask: data.rowType == ERowType.TASK ? true : false,
      countIndex: indexTree,
      customProperties: customProperties,
    });

    // Task
    if (data.rowType == ERowType.TASK) {
      let tasks = WBSStore.orderListByRowIndex(
        WBSStore.WBSRows.filter((r) => r.data.parentTask == dataTable[i].id)
      );

      for (let j = 0; j < tasks.length; j++) {
        const tasksData = tasks[j].data;
        id = tasks[j].id;
        customProperties = tasksData.customProperties;
        if (tasksData.rowType == ERowType.BLANK) {
          continue;
        }
        totalPercentageTasks =
          (roundBy(tasksData.total, rules) * 100) / WBSStore.WBS.data.totalCost;
        totalPercentageTasks = isNaN(totalPercentageTasks)
          ? 0
          : totalPercentageTasks;
        let newTotal =
          data.quantity == undefined
            ? 0
            : data.quantity * tasksData.quantity * tasksData.unitCost;

        let {
          priceLabor: tempPriceLabor,
          priceMat: tempPriceMat,
          priceOther: tempPriceOther,
        } = CostPlanStore.getRowLaborAndMaterialPrice(WBSRows, id);
        priceLabor = Number(tempPriceLabor);
        priceMat = Number(tempPriceMat);
        priceOther = Number(tempPriceOther);
        formatedData.push({
          "Cód. Estruturado": "", // tasksData.rowIndex
          Fonte: tasksData.rateLibraryId ? "RL" : "WBS", // TODO-706 - Origem
          Código: tasksData.rowCode,
          Descrição: tasksData.description,
          Coeficiente: tasksData.quantity,
          Quantidade:
            data.quantity == undefined ? 0 : data.quantity * tasksData.quantity,
          "Unid.": tasksData.unit,
          "Custo Unitário": roundBy(tasksData.unitCost, rules),
          "Custo M. O.": priceLabor,
          "Custo Mat.": priceMat,
          "Custo Outros": priceOther,
          Total: roundBy(newTotal, rules),
          "Preço de Venda":
            roundBy(tasksData.vendaBdi, rules) !== Infinity
              ? roundBy(tasksData.vendaBdi, rules)
              : undefined,
          "Preço Total":
            data.quantity == undefined
              ? 0
              : data.quantity * roundBy(tasksData.totalBdi, rules),
          "BDI (%)": "",
          "%": totalPercentageTasks,
          isStage: tasksData.rowType == ERowType.STAGE ? true : false,
          isTask: false,
          countIndex: tasksData.rowIndex,
          customProperties: customProperties,
        });
      }
    }
  }

  for (let i = 0; i < formatedData.length; i++) {
    if (formatedData[i]["Descrição"] == undefined) continue;
    worksheet.getCell("A" + (i + 13)).value =
      formatedData[i]["Cód. Estruturado"];
    worksheet.getCell("C" + (i + 13)).value = formatedData[i]["Código"];
    worksheet.getCell("D" + (i + 13)).value = formatedData[i]["Descrição"];
    worksheet.getCell("G" + (i + 13)).value = formatedData[i]["Coeficiente"];
    worksheet.getCell("H" + (i + 13)).value = formatedData[i]["Quantidade"];
    worksheet.getCell("I" + (i + 13)).value = formatedData[i]["Unid."];

    if (!formatedData[i]["isStage"]) {
      worksheet.getCell("J" + (i + 13)).value = formatedData[i]["Custo M. O."];
      worksheet.getCell("L" + (i + 13)).value = formatedData[i]["Custo Mat."];
      worksheet.getCell("M" + (i + 13)).value = formatedData[i]["Custo Outros"];
    }

    worksheet.getCell("O" + (i + 13)).value = formatedData[i]["Total"];
    if (!formatedData[i]["isStage"]) {
      worksheet.getCell("P" + (i + 13)).value =
        formatedData[i]["Preço de Venda"];
    }
    worksheet.getCell("Q" + (i + 13)).value = formatedData[i]["Preço Total"];
    worksheet.getCell("R" + (i + 13)).value = !formatedData[i]["isStage"]
      ? formatedData[i]["BDI (%)"]
      : "";
    worksheet.getCell("S" + (i + 13)).value = formatedData[i]["%"];
    if (formatedData[i]["customProperties"]) {
      for (let index = 0; index < stageCustomProperties.length; index++) {
        worksheet.getCell(letters[index] + (i + 13)).value =
          formatedData[i]["customProperties"][
            stageCustomProperties[index]["id"]
          ];
      }
    }

    if (!formatedData[i]["isStage"]) {
      worksheet.getCell("N" + (i + 13)).value =
        formatedData[i]["Custo Unitário"];
    }

    worksheet.getCell("J" + (i + 13)).numFmt = monetaryFormat;
    worksheet.getCell("L" + (i + 13)).numFmt = monetaryFormat;
    worksheet.getCell("M" + (i + 13)).numFmt = monetaryFormat;
    worksheet.getCell("N" + (i + 13)).numFmt = monetaryFormat;
    worksheet.getCell("O" + (i + 13)).numFmt = monetaryFormat;
    worksheet.getCell("P" + (i + 13)).numFmt = monetaryFormat;
    worksheet.getCell("Q" + (i + 13)).numFmt = monetaryFormat;

    worksheet.getCell("R" + (i + 13)).numFmt = "0.00";
    worksheet.getCell("S" + (i + 13)).numFmt = "0.00";
    worksheet.mergeCells(
      "A" + (i + 13).toString() + ":B" + (i + 13).toString()
    );
    worksheet.mergeCells(
      "D" + (i + 13).toString() + ":F" + (i + 13).toString()
    );
    worksheet.mergeCells(
      "J" + (i + 13).toString() + ":K" + (i + 13).toString()
    );

    let fillColor = fillLightGray;

    if (formatedData[i]["isStage"]) {
      if (formatedData[i]["countIndex"] == 0) fillColor = fillGray02;
      else if (formatedData[i]["countIndex"] == 1) fillColor = fillGreen;
      else if (formatedData[i]["countIndex"] == 2) fillColor = fillLightGreen;
      else fillColor = fillLighterGreen;

      let color = blackColor;
      let bold = false;
      if (
        formatedData[i]["countIndex"] <= 2 &&
        formatedData[i]["countIndex"] != 0
      ) {
        color = whiteColor;
      }

      if (formatedData[i]["countIndex"] <= 2) {
        bold = true;
      }

      const font = {
        ...fontNormal,
        color,
        bold,
      };

      worksheet.getCell("A" + (i + 13)).font = font;
      worksheet.getCell("B" + (i + 13)).font = font;
      worksheet.getCell("C" + (i + 13)).font = font;
      worksheet.getCell("D" + (i + 13)).font = font;
      worksheet.getCell("G" + (i + 13)).font = font;
      worksheet.getCell("H" + (i + 13)).font = font;
      worksheet.getCell("I" + (i + 13)).font = font;
      worksheet.getCell("J" + (i + 13)).font = font;
      worksheet.getCell("L" + (i + 13)).font = font;
      worksheet.getCell("M" + (i + 13)).font = font;
      worksheet.getCell("N" + (i + 13)).font = font;
      worksheet.getCell("O" + (i + 13)).font = font;
      worksheet.getCell("P" + (i + 13)).font = font;
      worksheet.getCell("Q" + (i + 13)).font = font;
      worksheet.getCell("R" + (i + 13)).font = font;
      worksheet.getCell("S" + (i + 13)).font = font;

      if (stageCustomProperties) {
        for (let index = 0; index < stageCustomProperties.length; index++) {
          worksheet.getCell(letters[index] + (i + 13)).font = font;
        }
      }
    } else {
      if (formatedData[i]["isTask"]) {
        fillColor = fillGray02;
      } else {
        fillColor = fillLightGray;
      }

      worksheet.getCell("A" + (i + 13)).font = fontNormal;
      worksheet.getCell("B" + (i + 13)).font = fontNormal;
      worksheet.getCell("C" + (i + 13)).font = fontNormal;
      worksheet.getCell("D" + (i + 13)).font = fontNormal;
      worksheet.getCell("G" + (i + 13)).font = fontNormal;
      worksheet.getCell("H" + (i + 13)).font = fontNormal;
      worksheet.getCell("I" + (i + 13)).font = fontNormal;
      worksheet.getCell("J" + (i + 13)).font = fontNormal;
      worksheet.getCell("L" + (i + 13)).font = fontNormal;
      worksheet.getCell("M" + (i + 13)).font = fontNormal;
      worksheet.getCell("N" + (i + 13)).font = fontNormal;
      worksheet.getCell("O" + (i + 13)).font = fontNormal;
      worksheet.getCell("P" + (i + 13)).font = fontNormal;
      worksheet.getCell("Q" + (i + 13)).font = fontNormal;
      worksheet.getCell("R" + (i + 13)).font = fontNormal;
      worksheet.getCell("S" + (i + 13)).font = fontNormal;

      if (stageCustomProperties) {
        for (let index = 0; index < stageCustomProperties.length; index++) {
          worksheet.getCell(letters[index] + (i + 13)).font = fontNormal;
        }
      }

      worksheet.getCell("A" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("B" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("C" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("D" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("G" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("H" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("I" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("J" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("L" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("M" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("N" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("O" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("P" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("Q" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("R" + (i + 13)).border = borderThinStyle;
      worksheet.getCell("S" + (i + 13)).border = borderThinStyle;
      if (stageCustomProperties) {
        for (let index = 0; index < stageCustomProperties.length; index++) {
          worksheet.getCell(letters[index] + (i + 13)).border = borderThinStyle;
        }
      }
    }
    worksheet.getCell("A" + (i + 13)).fill = fillColor;
    worksheet.getCell("B" + (i + 13)).fill = fillColor;
    worksheet.getCell("C" + (i + 13)).fill = fillColor;
    worksheet.getCell("D" + (i + 13)).fill = fillColor;
    worksheet.getCell("G" + (i + 13)).fill = fillColor;
    worksheet.getCell("H" + (i + 13)).fill = fillColor;
    worksheet.getCell("I" + (i + 13)).fill = fillColor;
    worksheet.getCell("J" + (i + 13)).fill = fillColor;
    worksheet.getCell("L" + (i + 13)).fill = fillColor;
    worksheet.getCell("M" + (i + 13)).fill = fillColor;
    worksheet.getCell("N" + (i + 13)).fill = fillColor;
    worksheet.getCell("O" + (i + 13)).fill = fillColor;
    worksheet.getCell("P" + (i + 13)).fill = fillColor;
    worksheet.getCell("Q" + (i + 13)).fill = fillColor;
    worksheet.getCell("R" + (i + 13)).fill = fillColor;
    worksheet.getCell("S" + (i + 13)).fill = fillColor;
    if (stageCustomProperties) {
      for (let index = 0; index < stageCustomProperties.length; index++) {
        worksheet.getCell(letters[index] + (i + 13)).fill = fillColor;
      }
    }

    worksheet.getCell("A" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("B" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("C" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("D" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("G" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("H" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("I" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("J" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("L" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("M" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("N" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("O" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("P" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("Q" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("R" + (i + 13)).alignment = { vertical: "middle" };
    worksheet.getCell("S" + (i + 13)).alignment = { vertical: "middle" };
    if (stageCustomProperties) {
      for (let index = 0; index < stageCustomProperties.length; index++) {
        worksheet.getCell(letters[index] + (i + 13)).alignment = {
          vertical: "middle",
        };
      }
    }
  }

  return worksheet;
};

const setColumnHeader = (
  worksheet: Worksheet,
  stageCustomProperties: FirebaseDocument<CustomPropertyModel>[],
  letters: string[]
) => {
  worksheet.getCell("A12").value = i18n.syntheticReport.structuredCode;
  worksheet.getCell("C12").value = i18n.syntheticReport.code;
  worksheet.getCell("D12").value = i18n.syntheticReport.description;
  worksheet.getCell("G12").value = i18n.syntheticReport.quantity;
  worksheet.getCell("H12").value = i18n.syntheticReport.serviceQuantity;
  worksheet.getCell("I12").value = i18n.syntheticReport.unity;
  worksheet.getCell("J12").value = i18n.syntheticReport.priceLabor;
  worksheet.getCell("L12").value = i18n.syntheticReport.priceMat;
  worksheet.getCell("M12").value = i18n.syntheticReport.priceOther;
  worksheet.getCell("N12").value = i18n.syntheticReport.serviceCost;
  worksheet.getCell("O12").value = i18n.syntheticReport.total;
  worksheet.getCell("P12").value = i18n.syntheticReport.precoVenda;
  worksheet.getCell("Q12").value = i18n.syntheticReport.precoTotal;
  worksheet.getCell("R12").value = i18n.syntheticReport.bdiPercent;
  worksheet.getCell("S12").value = "%";

  if (CustomPropertyStore.getWBSCustomProperties().length > 0) {
    for (let index = 0; index < stageCustomProperties.length; index++) {
      worksheet.getCell(letters[index] + "12").value =
        stageCustomProperties[index].data.label;
    }
  }
  worksheet.mergeCells("A12:B12");
  worksheet.mergeCells("D12:F12");
  worksheet.mergeCells("J12:K12");
  return worksheet;
};

export default getDataEAPAnalytical;



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/eapAnalyticalCustom.ts